/**
 * Impede que as teclas digitadas dentro de `el` cheguem ao Phaser, que escuta
 * na window e captura espaco e setas com preventDefault: sem isso o caractere
 * nunca entra no input, e digitar move o avatar. O Esc continua passando para
 * os listeners de document que fecham o painel.
 */
export function isolateKeyboardFromGame(el: HTMLElement): void {
  el.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") event.stopPropagation();
  });
}
